if (!window.__faqAccordionInitialized) {
  window.__faqAccordionInitialized = true;

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.faq-accordion').forEach(function (section) {
      const singleOpen = section.dataset.singleOpen !== 'false';
      const items = section.querySelectorAll('[data-faq-item]');

      items.forEach(function (item) {
        const trigger = item.querySelector('[data-faq-trigger]');
        const answer = item.querySelector('[data-faq-answer]');

        trigger.addEventListener('click', function () {
          const isOpen = trigger.getAttribute('aria-expanded') === 'true';

          if (singleOpen) {
            items.forEach(function (otherItem) {
              if (otherItem === item) return;
              const otherTrigger = otherItem.querySelector('[data-faq-trigger]');
              const otherAnswer = otherItem.querySelector('[data-faq-answer]');
              closeAnswer(otherTrigger, otherAnswer);
            });
          }

          if (isOpen) {
            closeAnswer(trigger, answer);
          } else {
            openAnswer(trigger, answer);
          }
        });
      });
    });

    function openAnswer(trigger, answer) {
      trigger.setAttribute('aria-expanded', 'true');
      answer.hidden = false;
      const height = answer.scrollHeight;
      answer.style.height = '0px';
      requestAnimationFrame(function () {
        answer.style.height = height + 'px';
      });
      answer.addEventListener('transitionend', function handler() {
        answer.style.height = 'auto';
        answer.removeEventListener('transitionend', handler);
      });
    }

    function closeAnswer(trigger, answer) {
      if (answer.hidden) return;
      trigger.setAttribute('aria-expanded', 'false');
      const height = answer.scrollHeight;
      answer.style.height = height + 'px';
      requestAnimationFrame(function () {
        answer.style.height = '0px';
      });
      answer.addEventListener('transitionend', function handler() {
        answer.hidden = true;
        answer.removeEventListener('transitionend', handler);
      });
    }
  });
}